export default function join(list, separator = ', ', and = `${separator}and `) {
  if (list.length > 2) {
    return `${list.slice(0, -1).join(separator)}${and}${list[list.length - 1]}`;
  }
  return list.join(and);
}
